var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"section-title__pointer",on:{"click":function($event){return _vm.$emit('click')}}},[_c('fa-icon',{attrs:{"icon":_vm.open ? 'minus' : 'plus'}}),_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_c('span',{attrs:{"slot":""},slot:"default"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50c06f2a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/followair/atualizacao-manual/components/sectionTitle/sectionTitle.vue
// module id = 555
// module chunks = 0